import { graphql } from "msw";
import { getFaker } from "Apimocks/utils/getFaker";
import { range } from "ramda";

const createActionData = (obj, idx, { faker }) => ({
    _id: faker.random.uuid(),
    status: "PENDING",
    _meta: {
        lastModifiedAt: faker.random.number({ min: Date.now(), max: Date.now() - 1000 * 60 * 60 * 24 * 7 * 2 })
    },
    _parent: {
        parent: {
            __typename: "Workflowinstance",
            _parent: {
                __typename: "v2Document",
                _id: `1234${idx}`,
                model: "v2Document"
            },
            currentStage: {
                name: faker.hacker.phrase()
            },
            log: {
                data: {
                    data: {
                        comment: faker.fake("{{lorem.word}} {{lorem.word}}"),
                        who: {
                            id: `123456${idx}`,
                            email: faker.internet.exampleEmail(),
                            firstname: faker.name.firstname,
                            lastname: faker.name.lastname
                        },
                        why: {
                            robot: {
                                t: faker.helpers.randomize([
                                    "init", "processAction", "progressWorkflowInstance", "doApplyWorkflowModelChange"
                                ]),
                                comment: faker.lorem.sentence(), 
                                ...faker.helpers.randomize([ { relatedKind: "action", related: `1234${idx}` }, { relatedKind: null, related: null } ])
                            }
                        }
                    }
                }
            }
        }
    },
    ...obj,
});

export const handlers = [
    graphql.query("getMyProjectActions", async (req, res, ctx) => {
        const faker = await getFaker();
        const data = {
            pending: {
                __typename: "myactionsInfo",
                edges: range(0, faker.random.number({ min: 1, max: 100 })).map(idx => ({
                    __typename: "myactionsEdge",
                    node: createActionData({
                        __typename: "Action",
                        status: "PENDING"
                    }, idx, { faker })
                }))
            },
            fulfilled: {
                __typename: "myactionsInfo",
                edges: range(0, faker.random.number({ min: 1, max: 100 })).map(idx => ({
                    __typename: "myactionsEdge",
                    node: createActionData({
                        __typename: "Action",
                        status: "FULFILLED"
                    }, idx, { faker })
                }))
            },
        };
        return res(
            ctx.delay(),
            ctx.data(data)
        );
    }),
];
